
import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import FormModelDisplay from '@/components/FormModelDisplay.vue';
import ProductRepository from '@/repositories/webshop/ProductRepository';
import ProductTranslationRepository from '@/repositories/webshop/ProductTranslationRepository';
import ProductImageRepository from '@/repositories/webshop/ProductImageRepository';
import ProductInventoryRepository from '@/repositories/webshop/ProductInventoryRepository';
import EmbeddedForm from '@/util/form/EmbeddedForm';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Subscription } from 'rxjs';
import FormModelEmbed from '@/components/FormModelEmbed.vue';
import ProductInventoryFormModel from '@/components/ProductInventoryFormModel.vue';

@Component({
    components: {
        ProductInventoryFormModel,
        GeneralScaffold,
        FormModelDisplay,
        FormModelEmbed,
    },
})
export default class ProductFormScreen extends Vue {
    @Inject()
    private readonly productRepository!: ProductRepository;
    @Inject()
    private readonly productTranslationRepository!: ProductTranslationRepository;
    @Inject()
    private readonly productImageRepository!: ProductImageRepository;
    @Inject()
    private readonly productInventoryRepository!: ProductInventoryRepository;
    private readonly singleton!: boolean;
    private loading = true;
    private displayError = false;
    private routeIdSubject = new BehaviorSubject<string>('new');
    private introspectionSubscription = new Subscription();
    private productId: number = -1;

    public created(): void {
        this.onRouteChanged();
        this.introspectionSubscription = this.routeIdSubject
            .pipe(
                map((id) => {
                    if (id === 'new') {
                        return this.singleton ? 1 : 0;
                    }
                    return parseInt(id, 10);
                }),
            )
            .subscribe((id) => {
                this.productId = id;
                this.loading = false;
                this.displayError = false;
            });
    }

    private GetFormData(): EmbeddedForm | null {
        return {
            relationship: 'inventories',
            parentRefKey: 'productId',
            i18nGroup: 'productInventories',
            entityRepository: this.productInventoryRepository,
            columns: ['amount', 'label', 'createdAt'],
        };
    }

    public get embeds() {
        return [
            {
                relationship: 'images',
                parentRefKey: 'productId',
                i18nGroup: 'product-image',
                entityRepository: this.productImageRepository,
                columns: ['imageName', 'order'],
                embeds: [
                    {
                        relationship: 'order',
                        parentRefKey: 'productId',
                        i18nGroup: 'product-image',
                        entityRepository: this.productImageRepository,
                        columns: ['imageName'],
                    },
                ],
            },
            {
                relationship: 'translations',
                parentRefKey: 'productId',
                i18nGroup: 'productTranslation',
                entityRepository: this.productTranslationRepository,
                columns: ['lang', 'name'],
            },
        ];
    }

    @Watch('$route')
    public onRouteChanged(): void {
        this.routeIdSubject.next(this.$route.params.hasOwnProperty('id') ? this.$route.params.id : 'new');
    }
}
